let mapBox = {
    source: {
        verification_source: 'verification-source',
    },
    layer: {
        marker_verification_layer: 'marker-verification-layer',
        heatmap_verification_layer: 'heatmap-verification-layer',
        circle_verification_layer: 'circle-verification-layer',
    },
    marker: {
        icon_img_id: 'default-marker-icon',
    },
}

let regions_arr = [{region: "NCR", color: "#7ef1b6"},{region: "CAR", color: "#15ea7d"}, {region: "Region I", color: "#098646"}, {region: "Region II", color: "#e7cd9f"}, 
    {region: "Region III", color: "#cda04d"}, {region: "Region IV-A", color: "#ffaa0d"}, {region: "Region IV-B", color: "#2af2e6"}, {region: "Region V", color: "#13c9be"},
    {region: 'Region VI', color: "#04605a"}, {region: 'Region VII', color: "#64d0ff"}, {region: 'Region VIII', color: "#30a7da"},{region: 'Region IX', color: "#06648c"},
    {region: 'Region X', color: "#a487f7"}, {region: 'Region XI', color: "#7245f2"}, {region: 'Region XII', color: "#35119b"}, {region: 'Region XIII', color: "#a665b0"}, 
    {region: 'BARMM', color: "#bf43d4"}
];

let countries_arr = ["Philippines"];

export {mapBox, regions_arr, countries_arr}